import React from 'react';
import { useEditorStore } from '../hooks/useEditorStore';
import { generateEdit, downloadModel } from '../services/api';
import styles from './Editor.module.css';

export default function Editor() {
  const {
    uploadedFilename,
    prompt,
    setPrompt,
    setLoading,
    setError,
    setSuccess,
    setActions,
    setModelUrl,
    loading,
  } = useEditorStore();

  const handleGenerateEdit = async () => {
    if (!uploadedFilename) {
      setError('Please upload a model first');
      return;
    }

    if (!prompt.trim()) {
      setError('Please enter a prompt');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const result = await generateEdit(uploadedFilename, prompt);

      setSuccess('Model edited successfully!');
      setActions(result.actions);

      // Create object URL for edited model
      const blob = await downloadModel(result.editedFilename);
      const url = URL.createObjectURL(blob);
      setModelUrl(url, true);

      // Download the file automatically
      const link = document.createElement('a');
      link.href = url;
      link.download = result.editedFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.panel}>
      <h2>Edit Model</h2>

      <div className={styles.inputGroup}>
        <label htmlFor="prompt">Edit Prompt</label>
        <textarea
          id="prompt"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="e.g., Make the car red metallic and remove the spoiler"
          className={styles.textarea}
          rows={4}
          disabled={loading}
        />
      </div>

      <button
        onClick={handleGenerateEdit}
        disabled={!uploadedFilename || loading}
        className={styles.button}
      >
        {loading ? 'Processing...' : '✨ Generate Edit'}
      </button>
    </div>
  );
}
